import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { Entity, ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation DeleteBlogPostBuilderOutlineSection($id: ID!) {
    deleteBlogPostBuilderOutlineSection(id: $id) {
      id
    }
  }
`;

export const deleteBlogPostBuilderOutlineSection = async (id: ID) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { id },
  });

  return getSingleProp<Entity>(result.data);
};
